IREP.blogs = (function() {
    "use strict";

    var options;

    var init = function(blogsOptions) {
        options = blogsOptions;
        if (IREP.options.user.geoCode === "ASMO") {
            $("#newsFeedWindow").on('pjax:end', function () {
                initHoverCards();

            });
            initHoverCards();
        }
    };

    var initHoverCards = function() {
        $(".authorName").hovercard({
            showCustomCard: true,
        });
    };

    return {
        init: init
    };


})();

